import { createSanitizedProxy } from '@plugins/shared/mocks/htmlSanitizedProxy';
import { Translations } from '@plugins/shared/types';

import de from './assets/i18n/de.json';
import en from './assets/i18n/en.json';

export type UserDetailsTranslationsShape = typeof en.userDetails;

export type UserDetailsTranslations =
  Translations<UserDetailsTranslationsShape>;

export const defaultUserDetailsTranslations: UserDetailsTranslations =
  createSanitizedProxy({
    en: { ...en.userDetails },
    de: { ...de.userDetails },
  });
